import { createFileRoute } from '@tanstack/react-router';
import * as React from 'react';

import { ReferralPageClient } from '@/components/referral/referral-page-client';

export const Route = createFileRoute('/_app/settings/referral')({
  component: ReferralSettingsPage,
});

function ReferralSettingsPage(): React.ReactElement {
  return <ReferralPageClient />;
}
